import Cookies from 'js-cookie';

export default {
  setCookie(name, value, options = {}) {
    Cookies.set(name, value, options);
  },
  getCookie(name) {
    return Cookies.get(name);
  },
  deleteCookie(name) {
    Cookies.remove(name);
  }
};